import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';
export const useDateFns = () => {
    /**
     * Formats a raw ISO date into something more readable
     * @param {string} date - Raw input date, expected to be in ISO format
     * @param {string} formatString - Format string to control how date is displayed
     * @see https://date-fns.org/v3.0.0/docs/format for documentation on format strings
     */
    const formatDate = (date, formatString = 'yyyy-MM-dd') => {
        try {
            return format(parseISO(date), formatString);
        }
        catch {
            return 'Invalid date';
        }
    };
    /**
     * Shows how long ago a date was relative to now. Eg "3 weeks ago", "1 year ago"
     * @param {string} date - Raw input date, expected to be in ISO format
     */
    const formatDistance = (date) => {
        try {
            return `${formatDistanceToNowStrict(parseISO(date))} ago`;
        }
        catch {
            return 'Invalid date';
        }
    };
    return {
        formatDate,
        formatDistance,
    };
};
